export default __webpack_public_path__ + "static/media/careersbg2.6032ea60.png";